import { UseQueryResult } from '@tanstack/react-query';
import { ApiStatus, Page } from '@types';

export const convertRQueryToApiStatus = (rQuery: UseQueryResult) => {
	const { data, isLoading, isSuccess, isError, error } = rQuery;
	return convertRQueryPropsToApiStatus(isLoading, isSuccess, isError, data, error);
};

export const convertRQueryPropsToApiStatus = (
	isLoading: boolean,
	isSuccess: boolean,
	isError: boolean,
	data: unknown | Page<unknown>,
	error: unknown,
) => {
	let apiStatus: ApiStatus = ApiStatus.IDLE;

	function isEmptyData() {
		const isUnexistingData = !data;
		const isEmptyArray = Array.isArray(data) && !data.length;
		const isEmptyPage = !!data && typeof data === 'object' && isPage(data) && !data.items.length;
		return isUnexistingData || isEmptyArray || isEmptyPage;
	}

	function isPage<T>(data: object): data is Page<T> {
		return (data as Page<T>).items !== undefined && (data as Page<T>).metadata !== undefined;
	}

	if (isError || error) {
		apiStatus = ApiStatus.ERROR;
	} else if (isLoading) {
		apiStatus = ApiStatus.PENDING;
	} else if (isSuccess) {
		if (isEmptyData()) {
			apiStatus = ApiStatus.EMPTY;
		} else {
			apiStatus = ApiStatus.FULFILLED;
		}
	}

	return apiStatus;
};
